module.exports = __webpack_public_path__ + "img/www.ebay.com.f3c2b76f.png";